import { useState } from "react";
import { GraduationCap, Globe2, Award, Users } from "lucide-react";
import { ACADEMY_MODALIDADES, IMG, track } from "@/data/content";
import { Reveal, SectionTag, TituloLineas, FotoRevelada } from "@/components/Reveal";
import Desplegable from "@/components/Desplegable";
import { useCertero } from "@/context/CerteroContext";

export default function Academy() {
  const { openLead } = useCertero();
  const [abierto, setAbierto] = useState(null);

  return (
    <section id="academy" className="scroll-mt-20 bg-navy px-4 py-14 sm:px-8 sm:py-20 lg:px-12 lg:py-32">
      <div className="mx-auto max-w-[1400px]">
        <Reveal>
          <SectionTag>Formación de pilotos</SectionTag>
          <TituloLineas
            lineas={[<>CERTERO <span className="text-certero">Academy</span></>]}
            className="mt-5 max-w-2xl font-display text-2xl font-bold uppercase leading-tight tracking-tight text-mist sm:text-3xl lg:text-4xl"
          />
          <p className="mt-5 max-w-xl text-sm leading-relaxed text-mist/80 sm:text-base">
            Formamos a los operadores que van a manejar y gestionar el dron agrícola.
          </p>
        </Reveal>

        <Reveal delay={0.12} className="mt-10">
          <FotoRevelada
            src={IMG.academyMain}
            alt="Pilotos en formación práctica con controles DJI RC en el aula de CERTERO Academy"
            className="aspect-[16/9] w-full border border-mist/15"
          />
        </Reveal>

        <Reveal delay={0.18} className="mt-9">
          <button
            data-testid="academy-btn-inscribirse"
            onClick={() => { track("academy_inscribirse_click", {}); openLead("academia", "CERTERO Academy"); }}
            className="inline-flex h-12 items-center gap-2 rounded-full bg-certero px-8 font-display text-xs font-bold uppercase tracking-[0.15em] text-ink transition-[background-color,transform] duration-300 hover:bg-[#4bc443] active:scale-95"
          >
            <GraduationCap className="h-4 w-4" /> Quiero inscribirme
          </button>
        </Reveal>

        <Reveal delay={0.1} className="mt-10">
          <Desplegable
            id="modalidades"
            titulo="Modalidades"
            icono={GraduationCap}
            compacto
            abierto={abierto === "modalidades"}
            onToggle={(id) => setAbierto((a) => (a === id ? null : id))}
            testid="academy-desplegable-modalidades"
          >
            <div className="flex-1">
              <p className="max-w-xl text-sm leading-relaxed text-mist/75">
                La academia de pilotos de CERTERO forma a los operadores que van a manejar y
                gestionar el dron agrícola: desde el productor y su personal hasta el emprendedor
                con su equipo de trabajo.
              </p>
              <ul className="mt-5 flex flex-col gap-3">
                {[
                  { icon: Globe2, t: "Convenios con instructores internacionales" },
                  { icon: Award, t: "Certificación de pilotos por CERTERO" },
                  { icon: Users, t: "Capacitación a todo el equipo del productor con la compra" },
                ].map((f) => (
                  <li key={f.t} className="flex items-center gap-3 text-sm text-mist/85">
                    <f.icon className="h-4 w-4 shrink-0 text-certero" strokeWidth={1.5} /> {f.t}
                  </li>
                ))}
              </ul>

              <div className="mt-7 grid grid-cols-1 gap-4 sm:grid-cols-3">
                {ACADEMY_MODALIDADES.map((m, i) => (
                  <div
                    key={m.id}
                    data-testid={`academy-modalidad-${m.id}`}
                    className="border border-mist/15 bg-abyss/40 p-5"
                  >
                    <span className="font-mono text-[10px] tracking-[0.25em] text-certero">
                      {String(i + 1).padStart(2, "0")} / MODALIDAD
                    </span>
                    <h3 className="mt-3 font-display text-base font-bold uppercase tracking-wide text-mist">{m.t}</h3>
                    <p className="mt-1 text-sm leading-relaxed text-mist/70">{m.d}</p>
                  </div>
                ))}
              </div>

              <div className="mt-7 border border-mist/15 bg-abyss/40 p-6" data-testid="academy-cursos-futuros">
                <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-certero">Próximamente</p>
                <p className="mt-3 max-w-lg text-sm leading-relaxed text-mist/75">
                  La plataforma de cursos virtuales de CERTERO Academy está en preparación. Déjenos
                  sus datos con el botón «Quiero inscribirme» y será de los primeros en acceder
                  cuando se abra la inscripción.
                </p>
              </div>
            </div>
          </Desplegable>
        </Reveal>
      </div>
    </section>
  );
}
